import { useCallback, useState } from 'react';

export const useMenuOpenState = (disabled: boolean) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const closeMenu = useCallback(() => setMenuOpen(false), []);

  const rootProps = {
    open: disabled ? false : menuOpen,
    onOpenChange: setMenuOpen,
  };

  return {
    rootProps,
    menuOpen,
    closeMenu,
  };
};
